import { render, staticRenderFns } from "./gameCard.vue?vue&type=template&id=90d8ac96&scoped=true"
import script from "./gameCard.vue?vue&type=script&lang=js"
export * from "./gameCard.vue?vue&type=script&lang=js"
import style0 from "./gameCard.vue?vue&type=style&index=0&id=90d8ac96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d8ac96",
  null
  
)

export default component.exports